import React, { useEffect, useState } from "react";
import Form from "./Form";
import { motion } from "motion/react";

const Inquire = ({ open, setOpen, service, type, shipment }) => {
  //   console.log(produce.filter((item) => item.selected));
  //   const [s, setS] = useState([]);
  //   const c = [
  //     "Avocado",
  //     "Mango",
  //     "Pineapple",
  //     "Banana",
  //     "Passion Fruit",
  //     "Custard Apple",
  //     "Coffee",
  //     "Ginger",
  //     "Flowers",
  //     "Veggies",
  //   ];

  //   useEffect(() => {
  //     if (service) {
  //     //   setS(service.filter((item) => item.selected));
  //       console.log(s);
  //     }
  //   }, [service]);
  return (
    <motion.div
      initial={{ x: "-100vw" }}
      animate={
        open
          ? {
              x: 0,
              transition: { x: { duration: 0 } },
            }
          : { x: "-100vw", transition: { x: { duration: 0, delay: 0.6 } } }
      }
      className={`modal-container`}
    >
      <motion.div
        initial={{ x: "-100vw", y: 20, opacity: 0 }}
        animate={
          open
            ? {
                x: 0,
                y: 0,
                opacity: 1,
                transition: {
                  x: { duration: 0 },
                  y: { duration: 0.3 },
                  opacity: { duration: 0.3 },
                },
              }
            : {
                x: "-100vw",
                y: 20,
                opacity: 0,
                transition: { x: { duration: 0, delay: 0.3 }, duration: 0.3 },
              }
        }
        style={{ justifyItems: "center" }}
        className={`modal lg:w-[calc(100%-8rem)] w-[calc(100%-4rem)]`}
      >
        <div
          onClick={() => setOpen(!open)}
          style={{ zIndex: 999999999999999 }}
          className="w-full"
        ></div>
        <Form
          type={type}
          service={service}
          shipment={shipment}
          setOpen={setOpen}
        />
      </motion.div>
      {/* <div
        className={`modal-overlay ${!open && "hide-overlay"}`}
        onClick={() => setOpen(!open)}
      ></div> */}
      <motion.div
        initial={{ x: "-100vw", y: 0, opacity: 0 }}
        animate={
          open
            ? {
                x: 0,
                y: 0,
                opacity: 1,
                transition: { x: { duration: 0 } },
              }
            : {
                x: "-100vw",
                y: 0,
                opacity: 0,
                transition: {
                  opacity: { delay: 0.3 },
                  x: { duration: 0, delay: 0.6 },
                },
              }
        }
        className={`modal-overlay`}
        onClick={() => setOpen(!open)}
      ></motion.div>
    </motion.div>
  );
};

export default Inquire;
